import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Text } from '../Text/index.js';

/**
 * Headings communicate the organization of the content on the page.
 *
 * Heading extends from `Text` so you can use all of its style props.
 *
 * Renders a `<h2>` tag by default.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/heading#usage)
 * - [Props](https://blockparty.endpoint.com/components/heading#props)
 * <br />
 *
 */
const Heading = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    size = 'fontSize70',
    dataTestId = 'heading',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Text, _extends({
    ref: forwardedRef,
    as: "h2",
    "data-test-id": dataTestId,
    fontWeight: "semi",
    size: size
  }, rest));
});

export { Heading };
